var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("ConfigBox", {
        attrs: {
          formIsInvalid: _vm.$v.default_bank_account.$invalid,
          callback: (password) =>
            _vm.saveConfig(
              _vm.default_bank_account,
              "UPDATE_RECIPIENT_DEFAULT_BANK_ACCOUNT",
              password
            ),
          title: _vm.$t("recipients.details.box.recipient_settings"),
          hasPassword: true,
          mfaNeeded: !_vm.hasUserTwoFactorAuthentication,
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c("BankAccount", {
                  attrs: {
                    default_bank_account: _vm.default_bank_account,
                    vuelidate: _vm.$v,
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("ConfigBox", {
        attrs: {
          formIsInvalid: _vm.$v.automatic_anticipation_settings.$invalid,
          callback: (password) =>
            _vm.saveConfig(
              _vm.automatic_anticipation_settings,
              "UPDATE_RECIPIENT_ANTICIPATION_SETTINGS",
              password
            ),
          title: _vm.$t("recipients.details.box.recipient_prepayment_settings"),
          hasPassword: true,
          mfaNeeded: !_vm.hasUserTwoFactorAuthentication,
        },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c("PrepaymentSettings", {
                  attrs: {
                    automatic_anticipation_settings:
                      _vm.automatic_anticipation_settings,
                    vuelidate: _vm.$v,
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _c("ConfigBox", {
        attrs: {
          formIsInvalid: _vm.transferSettingsIsInvalid,
          callback: _vm.saveEditTransferSettings,
          title: _vm.$t("recipients.details.box.transfer_settings"),
          hasPassword: true,
          mfaNeeded: !_vm.hasUserTwoFactorAuthentication,
        },
        on: { cancelEdit: _vm.cancelEditTransferSettings },
        scopedSlots: _vm._u([
          {
            key: "content",
            fn: function () {
              return [
                _c("TransferSettings", {
                  attrs: {
                    transferSettingsIsInvalid: _vm.transferSettingsIsInvalid,
                    transfer_settings: _vm.transferSettingsEditData,
                  },
                  on: {
                    "update:transferSettingsIsInvalid": function ($event) {
                      _vm.transferSettingsIsInvalid = $event
                    },
                    "update:transfer-settings-is-invalid": function ($event) {
                      _vm.transferSettingsIsInvalid = $event
                    },
                  },
                }),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }